module.exports = __WEBPACK_EXTERNAL_MODULE__COVALA_DI__4c26d2a7__;